module.exports = __webpack_public_path__ + "img/NL.1800a419.webp";